$('.Tabs').each(function(i, tab) {
    var tabRoot = $(this);
    var tabTrigger = '.TabTrigger';
    var tabContent = '.TabContent';
    var findTabTrigger = tabRoot.find(tabTrigger);
    var findTabContent = tabRoot.find(tabContent);

    findTabTrigger.attr('aria-selected', false);
    findTabContent.attr('hidden', true);

    findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
    findTabContent.eq(0).addClass('__active').attr('hidden', false);
    

    findTabTrigger.click(function(e) {
        e.preventDefault();
        var dataSet = $(this).data('set');

        tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
        
        $(this).attr('aria-selected', true).addClass('__active');

        tabRoot.find(tabContent + '.__active').attr('hidden', true).removeClass('__active');
        tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('hidden', false).addClass('__active');
        
    });
});

const tabs = document.querySelectorAll('.tabsblock');

for( i=0; i< tabs.length; i++ ) {
  
    tabs[i].classList.add('tabsblock-swiper-container-' + i);

    var slider = new Swiper('.tabsblock-swiper-container-' + i +' .tabpanel-head-list' , {
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 4,
        spaceBetween: 0,
        a11y: {
            enabled: true,
            containerRole: 'tablist',
            slideRole: 'tab',
        },
        navigation: {
            nextEl: '.tabsblock.tabsblock-swiper-container-' + i + ' .swiper-button-next',
            prevEl: '.tabsblock.tabsblock-swiper-container-' + i + ' .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.4,
            },
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }

        
    });

    if (slider && slider.wrapperEl) {
        slider.wrapperEl.removeAttribute('aria-live');
    }
    const liveRegion = slider.el.querySelector('.swiper-notification');
    if (liveRegion) {
        liveRegion.remove();
    }
}